import { Skeleton } from '@/components/ui/skeleton'

const RestaurantPerformanceSkeleton = () => {
  return (
    <div className='bg-white rounded-[1.15rem] p- flex flex-col justify-between'>
      {/* Header */}
      <div className='flex justify-between items-center p-5'>
        <Skeleton className='h-6 w-48' />
        <Skeleton className='h-10 w-10 rounded-full' />
      </div>

      {/* Chart Content */}
      <div className='px-5 pb-5'>
        <div className='relative'>
          {/* Chart Container */}
          <div className='mx-auto aspect-square max-h-[300px] flex items-center justify-center'>
            {/* Pie Chart Skeleton */}
            <div className='relative w-64 h-64'>
              {/* Outer Circle */}
              <div className='w-full h-full rounded-full border-8 border-gray-200'></div>
              {/* Inner Circle */}
              <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gray-100 rounded-full'></div>
              {/* Center Icon */}
              <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-gray-200 rounded-md'></div>
            </div>
          </div>

          {/* Legend */}
          <div className='flex justify-center gap-8 mt-6'>
            <div className='flex items-center gap-2'>
              <Skeleton className='w-3 h-3 rounded-full' />
              <Skeleton className='h-4 w-32' />
              <Skeleton className='h-4 w-16' />
            </div>
            <div className='flex items-center gap-2'>
              <Skeleton className='w-3 h-3 rounded-full' />
              <Skeleton className='h-4 w-36' />
              <Skeleton className='h-4 w-16' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RestaurantPerformanceSkeleton
